export interface LinearPersonSummary {
	linearUserId: string
	name?: string | null
	avatarUrl?: string | null
}

export interface ResolvedLinearPerson {
	name: string
	avatarUrl: string | null
}

// Linear search results carry the person; synced rows only carry the id.
export function resolveLinearPerson(
	linearUserId: string | null | undefined,
	users: ReadonlyArray<LinearPersonSummary> | null | undefined,
	inline?: { name?: string | null; avatarUrl?: string | null } | null,
): ResolvedLinearPerson | null {
	const user =
		inline ??
		(linearUserId
			? users?.find((it) => it.linearUserId === linearUserId)
			: undefined)
	if (!user?.name) return null
	return { name: user.name, avatarUrl: user.avatarUrl ?? null }
}
